import React from 'react'
// @ts-ignore no types
import { Link } from 'react-router-dom'

export const ROOT_CRUMB = <Link to='/'>Morpheus</Link>
export const TRANSACTIONS_CRUMB = <Link to='/transactions'>Transactions</Link>
export const DASHBOARD_ROOT_CRUMB = <Link to='/dashboard'>Dashboards</Link>
export const USERS_CRUMB = <Link to='/user-management'>User Management</Link>
export const ORGANIZATIONS_CRUMB = (
  <Link to='/organizations'>Organizations</Link>
)
export const ACTIVITY_TIMELINE_CRUMB = (
  <Link to='/organizations/activitytimeline'>Activity Timeline</Link>
)

// Schedule (events/venues)
export const VENUE_TEMPLATES_CRUMB = (
  <Link to='/schedule/venue-templates'>Venue Templates</Link>
)
export const EVENT_TEMPLATES_CRUMB = (
  <Link to='/schedule/event-templates'>Event Templates</Link>
)
export const EVENT_CRUMB = <Link to='/schedule/events'>Events</Link>
export const VENUES_CRUMB = <Link to='/schedule/venues'>Venues</Link>
